import { CatalogMenuItemsParams, MenuItemsDataType } from './interfaces';

export const menuItemsData: Record<
	MenuItemsDataType,
	Pick<CatalogMenuItemsParams, 'href' | 'label' | 'unavailableTooltip'>
> = {
	promotions: {
		href: '/promocoes',
		label: 'Promoções',
		unavailableTooltip: 'Sem promoções no momento',
	},
	brands: {
		href: '/nossas-marcas',
		label: 'Nossas Marcas',
	},
	releases: {
		href: '/lancamentos',
		label: 'Lançamentos',
		unavailableTooltip: 'Sem lançamentos no momento',
	},
	suggestionsProduct: {
		href: '/sugestoes-de-pedidos',
		label: 'Sugestão de pedidos',
		unavailableTooltip: 'Sem sugestões no momento',
	},
	incentiveCampaign: {
		href: '/bateu-ganhou',
		label: 'Bateu, Ganhou',
	},
};
